import {
  BaseInputGroup,
  BaseStaticSelect,
} from "@/components/input/CustomInputs";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import axiosInstance from "@/utils/axiosInstance";
import { Copy, MapPin } from "lucide-react";
import React, { FC } from "react";
import { useState } from "react";
import { toast } from "sonner";

interface Props {
  id: number;
  settings_id: number;
  lat: number;
  lng: number;
}

const OrderTrackLink: FC<Props> = ({ id, settings_id, lat, lng }) => {
  const [formProp, setFormProp] = useState<{ expiryTime: string }>({
    expiryTime: "",
  });
  const [open, setOpen] = useState(false);
  const [generatedLink, setGeneratedLink] = React.useState<string | null>(null);

  const generateLink = async () => {
    if (!formProp.expiryTime) {
      toast("Select expiry time");
      return;
    }
    try {
      const response = await axiosInstance.put(
        `/taxi-orders/update-track-time`,
        {
          orderId: id,
          time: Number(formProp.expiryTime),
        },
      );

      if (response.data) {
        const link = `https://track-order.auttom.io?settings_id=${settings_id}&order_id=${id}&clat=${lat}&clng=${lng}`;
        setGeneratedLink(link);
      }
    } catch (error) {
      toast(error.response.data.message);
      console.error("Error generating track link:", error);
    }
  };

  return (
    <>
      <DropdownMenuItem
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <MapPin />
        Track link
      </DropdownMenuItem>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <DialogTitle>Generate live location</DialogTitle>
          <BaseStaticSelect
            id="expiryTime"
            label="Expiration time"
            value={formProp.expiryTime}
            setValue={setFormProp}
            data={[
              { label: "2 minutes", value: "2" },
              { label: "5 minutes", value: "5" },
              { label: "10 minutes", value: "10" },
              { label: "30 minutes", value: "30" },
              { label: "1 hour", value: "60" },
              { label: "3 hours", value: "180" },
            ]}
          />
          {generatedLink && (
            <BaseInputGroup
              readonly={true}
              id=""
              width="w-10"
              label="Share current location"
              value={generatedLink}
              setProp={() => {}}
              required={false}
            >
              <Button
                variant="outline"
                onClick={() => {
                  navigator.clipboard.writeText(generatedLink);
                  toast("Location copied");
                }}
              >
                <Copy className="w-4 h-4" />
              </Button>
            </BaseInputGroup>
          )}
          <div className="flex justify-end">
            <Button onClick={generateLink}>Generate link</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderTrackLink;
